import {
    CONNECTION_TYPE_DAV,
    CONNECTION_TYPE_SHPLIST,
    CONNECTION_TYPE_SHPLISTFORM,
    CONNECTION_TYPE_WEBSERVICE,
    CONNECTION_TYPE_XMLFILE,
} from '../../DataConnections/dataConnection.types';
import { QRULES_ERROR_NAME } from '../constants/errors';
import {
    paramDsName,
    paramListGuid,
    paramListName,
    paramUrl,
} from '../constants/parameterNames';
import { typeDataConnection } from '../constants/parameterTypes';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataConnection } from '../helpers/qRules.dataConnection.helpers';

const optionalParameters = [
    {
        name: paramListGuid,
        description:
            'GUID for the SharePoint List - either this or listname is required if data connection is to a SharePoint List.',
    },
    {
        name: paramListName,
        description:
            'SharePoint List name - either this or listguid is required if data connection is to a SharePoint List.',
    },
];

const requiredParameters = [
    {
        name: paramDsName,
        description: 'Name of data connection where URL should be changed',
        type: typeDataConnection,
    },
    {
        name: paramUrl,
        description: 'New URL for the data connection',
    },
];

const changeConnectionUrlListGuidNeeded = `You must provide ${paramListGuid} or ${paramListName} parameter if changing the URL for a SharePoint List data connection.`;
const changeConnectionUrlUnknownConnectionType =
    'ChangeConnectionUrl is not supported for this connection type';
const description =
    'Changes the URL for a data connection (web service, XML file, etc.). Cannot be used for SharePoint list connections.';

function executeAsync({ dataConnections, parameters }) {
    const dsName = getParamValue(parameters, paramDsName);
    const url = getParamValue(parameters, paramUrl);
    const listGuid = getParamValue(parameters, paramListGuid);
    const listName = getParamValue(parameters, paramListName);
    const conn = getDataConnection(dataConnections, dsName);

    try {
        switch (conn.type) {
            case CONNECTION_TYPE_XMLFILE:
            case CONNECTION_TYPE_WEBSERVICE:
            case CONNECTION_TYPE_DAV:
                conn.setUrl(url);
                break;

            case CONNECTION_TYPE_SHPLIST:
            case CONNECTION_TYPE_SHPLISTFORM:
                if (!(listGuid || listName)) {
                    let errorObj = new Error(changeConnectionUrlListGuidNeeded);
                    errorObj.name = QRULES_ERROR_NAME;

                    throw errorObj;
                }

                conn.setUrlAndListInfo(url, listGuid, listName);
                break;

            default:
                let errorObj = new Error(
                    changeConnectionUrlUnknownConnectionType,
                );
                errorObj.name = QRULES_ERROR_NAME;

                throw errorObj;
        }

        return url;
    } catch (e) {
        if (e.name === QRULES_ERROR_NAME) {
            throw e;
        }

        throw new Error(
            'An error occurred trying to change the connection URL: ' +
                e.message,
        );
    }
}

const ChangeConnectionUrl = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default ChangeConnectionUrl;
